
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/festivals/[festivalId]/extras",
      function () {
        return require("private-next-pages/festivals/[festivalId]/extras/index.tsx");
      }
    ]);
  